export default {
  template: `<div :class="{'has-error': errors}">
               <slot></slot>
               <span class="help-block" v-if="errors">{{errors}}</span>
             </div>`,
  props: ['errors']
}
